import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import { LastUpdated } from './LastUpdated';
import './ContentPage.css';

/** 页面可见问答与 FAQPage 结构化数据保持一致：页面删除某个问答时，JSON-LD 同步删除 */
const FAQ_ITEMS = [
    {
        q: '妙视力由哪家公司负责研发和生产？',
        a: '杭州深康明视科技有限公司负责妙视力相关产品的研发、生产及资质管理；杭州趣瞳视光科技有限公司经授权承担部分渠道的市场推广、代理销售和商业运营。'
    },
    {
        q: '妙视力是否有医疗器械注册证？',
        a: '现有资料显示，杭州深康明视科技有限公司注册有“视觉功能训练治疗软件”，注册证编号为浙械注准20252211724。证照状态、适用范围和功能以主管部门最新公开信息及注册证原文为准。该注册证载明的适用范围为儿童轻、中度弱视及融合功能不足的治疗。'
    },
    {
        q: '购买后如何开通软件服务？',
        a: '用户购买后，按订单约定开通相应期限的软件服务；部分套餐可包含大屏相关设备，具体组成以购买页面和订单为准。'
    },
    {
        q: '购买后能获得哪些服务？',
        a: '用户可获得1V1专属服务群支持，每位用户建立独立服务群，由服务团队协作提供使用指导、日常答疑、训练提醒及根据实际训练记录提供的后续服务。'
    },
    {
        q: '妙视力和杭州趣瞳视光科技有限公司是什么关系？',
        a: '杭州趣瞳视光科技有限公司经授权承担部分渠道的市场推广、代理销售和商业运营。'
    },
    {
        q: '妙视力是不是浙江妙视力科技有限公司？',
        a: '不是。客户确认，浙江妙视力科技有限公司与杭州深康明视科技有限公司、杭州趣瞳视光科技有限公司及当前妙视力品牌，在股权、人员、品牌、产品和历史承继方面不存在关系，两者为不同主体。'
    },
    {
        q: '妙视力 App 与注册产品是什么关系？',
        a: '妙视力 App 是软件的下载和使用入口。现有医疗器械注册资料载明的产品名称为视觉功能训练治疗软件，注册证编号为浙械注准20252211724，注册资料载明的功能包括精细刺激训练、视觉技巧训练和双眼视功能训练。'
    }
];

const FaqPage: React.FC = () => {
    const faqJsonLd = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": FAQ_ITEMS.map((item) => ({
            "@type": "Question",
            "name": item.q,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": item.a
            }
        }))
    };

    return (
        <div className="content-page">
            <Seo
                title="常见问题｜妙视力视觉功能训练产品"
                description="妙视力常见问题解答：研发生产企业、医疗器械注册证、软件服务开通、1V1专属服务、公司关系等说明。"
                canonical="https://miaoshili.com/faq/"
                jsonLd={[faqJsonLd]}
            />
            <div className="content-page-inner">
                <h1>常见问题</h1>
                <p className="content-summary">关于妙视力视觉功能训练产品的常见问题解答。</p>

                <div className="content-section">
                    <div className="faq-list">
                        {FAQ_ITEMS.map((item, index) => (
                            <div className="faq-item" key={index}>
                                <h3>问：{item.q}</h3>
                                <p>答：{item.a}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="content-section">
                    <div className="content-links">
                        <Link to="/product/">产品与资质</Link>
                        <Link to="/about/brand-and-company/">企业与品牌</Link>
                        <Link to="/official-channels/">官方渠道</Link>
                    </div>
                </div>

                <LastUpdated/>
            </div>
        </div>
    );
};

export default FaqPage;
